/**
 * Re-export from the shared schema-driven hook.
 * All message data comes from FlatBuffer enums, not the backend /messages/ API.
 */
import { useSchemaMessages } from "../useSchemaMessages";

/**
 * Fetches the message dictionary, paged.
 *
 * Resolves a JWT first and passes it to the query, which stays skipped until the
 * token arrives. Scoped to the globally selected organisation unless overridden.
 */
export default function useGetAllMessages(opts?: {
  page?: number;
  limit?: number;
  messageTypeId?: string;
  deviceType?: string;
}): ReturnType<typeof useSchemaMessages> {
  return useSchemaMessages(opts);
}
